// extracted by mini-css-extract-plugin
export default {"cropFormContainer":"CropForm_cropFormContainer__KcLgm"};